module.exports = {"232722100":"塔河镇","232722101":"瓦拉干镇","232722102":"盘古镇","232722103":"古驿镇","232722200":"十八站鄂伦春族乡","232722201":"依西肯乡","232722202":"开库康乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/232722.json
// module id = 901
// module chunks = 0